module.exports = __webpack_public_path__ + "static/media/footer-pro.39ad2633.jpg";